<template>

    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--lg mcc-dialog--primary" ref="themeDialogRef" id="user-defined-theme">
            <form novalidate id="adminThemesDialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Customize and manage themes</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="handleCloseDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">

                            <div class="mcc-col">
                                <div class="spinner-overlay" v-if="savingTheme">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                            style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none"
                                                stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mfc-slim-select-wrapper mu-mb-03">
                                    <label for="themeCode" class="mu-mb-00">Select Theme</label>
                                    <select v-if="!savingTheme" @change="changeTheme" :value='selectedTheme'
                                        id="themeInput" ref="themeRef" name="myInput" block label="Select theme">
                                        <option value="">--Select theme--</option>
                                        <option :selected='selectedTheme == theme.code'
                                            v-for="(theme, key) in userDefinedThemes" :key="key" :value="theme.code">
                                            {{ theme.name }}</option>
                                    </select>
                                </div>

                                <div class="mu-d-flex mu-justify-content-end">
                                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                        <button type="button" class="mcc-button mcc-button--primary" @click="addNew">
                                            <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span
                                                class="mcc-button__label">Add new</span></button>
                                        <button type="button" class="mcc-button mcc-button--primary"
                                            v-show="selectedTheme && selectedTheme != ''" @click="edit">
                                            <mcc-icon name="edit" aria-hidden="true"></mcc-icon><span
                                                class="mcc-button__label">Edit</span></button>
                                        <button type="button" class="mcc-button mcc-button--soft-danger"
                                            v-show="selectedTheme && selectedTheme != ''" @click="deleteTheme">
                                            <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span
                                                class="mcc-button__label">Delete</span></button>
                                    </div>
                                </div>
                                <div class="mcc-card mu-mt-03" v-if="mode">
                                    <div
                                        class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                        <h2 class="mcc-card__title">
                                            title
                                        </h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mfc-input-wrapper mfc-form-input-container">
                                            <label for="themeName">Theme name</label>
                                            <input type="text" required="" name="themeName" maxlength="255"
                                                id="themeName" ref="themeNameRef" :pattern="nameRegex"
                                                :value="themeDTO.name" @input="themeDTO.name = $event.target.value">
                                            <div class="mfc-help-text">Enter theme name of your choice</div>

                                        </div>
                                        <div class="mfc-input-wrapper mfc-form-input-container" v-show="mode == 'add'">
                                            <label for="ThemeCode">Theme code</label>
                                            <input type="text" required="" name="newThemeCode" maxlength="255"
                                                ref="themeCodeRef" :pattern="nameRegex" :value="themeDTO.code"
                                                @input="themeDTO.code = $event.target.value" id="ThemeCode">
                                            <div class="mfc-help-text">Enter unique theme code e.g., theme-adv</div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                            <div class="mcc-col">
                                <!-- <mosaic-user-defined-theme id="userDefinedTheme"></mosaic-user-defined-theme> -->

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline"
                                @click="handleCloseDialog()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="saveTheme()">Save
                                theme</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>

</template>

<script>
import {
    mapMutations,
    mapState
} from "vuex";
import {
    EventBus
} from "@/services/event-bus.js";
import constantMessages from "@/messages";
import AdminThemesAPI from "@/services/AdminThemesAPI";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../formvalid.js';
export default {
    computed: {
        ...mapState(['userDefinedThemes'])

    },
    created() {
        let self = this;
        EventBus.$on("open-theme-dialog", (currentThemeData) => {
            self.adminSelectedThemeDTO = currentThemeData;
            self.$refs.themeDialogRef.show();
            self.userDefinedThemes.forEach(item => {
                item['text'] = item.name;
                item['value'] = item.code;
            });
            document.getElementById("themeInput").setData(self.userDefinedThemes);
            document.getElementById("themeInput").value = self.selectedTheme;
        });

    },
    data() {
        return {
            mode: null,
            title: '',
            themeDTO: {},
            selectedTheme: '',
            savingTheme: false,
            selectedThemeDTO: {},
            adminSelectedThemeDTO: '',
            nameRegex: constantMessages.PATTERNS["name"],
        };
    },
    mounted() {
        setTimeout(() => {
            const previewButton = document.querySelector('#user-defined-theme-save-button > button')
            if (previewButton != null) {
                previewButton.addEventListener('click', () => {
                    this.$store.dispatch('updatePreviewMode', true)
                });
            }
        }, 2000);

        EventBus.$on("exitPreviewMode", () => {
            this.selectedTheme = '';
            this.$refs.themeRef.value = '';
            this.reset();
        })
        new SlimSelect({
            select: '#themeInput',
        })

    },
    methods: {
        handleCloseDialog() {
            this.$refs.themeDialogRef.close()
            this.$store.dispatch('updatePreviewMode', false)
            const variables = JSON.parse(this.adminSelectedThemeDTO.variables);
            const theme = document.querySelector('mosaic-user-defined-theme')
            theme.theme = variables;
            theme.preview();
        },
        hideDeleteThemeDialog(e) {
            if (e.detail.value) {

            }
        },
        preview() {
            const theme = document.querySelector('mosaic-user-defined-theme')
            theme.generateCss()
            theme.preview()
        },
        applyCustomTheme() {
            const theme = document.querySelector('mosaic-user-defined-theme')
            theme.preview()
        },
        validateThemeName() {
            let result = true;

            this.userDefinedThemes.forEach(theme => {
                if (this.themeDTO.id != theme.id && (this.themeDTO.name == theme.name || this.themeDTO.name == "Default")) {
                    result = false;
                }
            })
            return result;
        },
        validateThemeCode() {
            let result = true;
            this.userDefinedThemes.forEach(theme => {
                if (this.themeDTO.id != theme.id && (this.themeDTO.code == theme.code || this.themeDTO.code == "theme-default")) {
                    result = false;
                }
            })
            return result;
        },
        saveTheme() {

            let form = $('#adminThemesDialog')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.handleCloseDialog()
            if ((this.mode == 'edit' && this.selectedTheme && this.selectedTheme != '') || this.mode == 'add') {
                if (!this.validateThemeName()) {
                    this.$refs.themeNameRef.invalid = true
                    this.$refs.themeNameRef.invalidText = 'Theme cannot be created as theme name already exists'
                    return;
                }
                if (!this.validateThemeCode()) {
                    this.$refs.themeCodeRef.invalid = true
                    this.$refs.themeCodeRef.invalidText = 'Theme code should be unique'
                    return;
                }
                const theme = document.querySelector('mosaic-user-defined-theme')
                const css = theme.generateCss(null, { customized: true })
                theme.preview();
                this.themeDTO.variables = JSON.stringify(css.variables)
                this.savingTheme = true
                AdminThemesAPI.saveUserDefinedTheme(this.themeDTO).then(result => {
                    let notification = {
                        "msg": ""
                    }
                    if (result && !result.error) {
                        this.themeDTO = result.data
                        notification.msg = 'Theme saved successfully'
                        EventBus.$emit('success-notification', notification);
                        setTimeout(() => {
                            this.selectedTheme = '';
                            this.$refs.themeRef.value = '';
                            this.reset();
                            this.$refs.themeDialogRef.close()
                            EventBus.$emit('reload-admin-themes');
                        }, 500);
                    } else if (result && result.error) {

                        notification.msg = result.message;

                        EventBus.$emit('error-notification', notification);
                    }

                }).finally(() => {
                    this.savingTheme = false

                })
            } else {
                let notification = {
                    "msg": "Please select a theme to edit or create new theme"
                }
                EventBus.$emit('error-notification', notification);
            }
        },
        addNew() {
            this.mode = 'add'
            this.themeDTO = {
                id: null,
                code: '',
                name: '',
                variables: ''
            }
            setTimeout(() => {
                this.$refs.themeNameRef.invalid = false;
                this.$refs.themeCodeRef.invalid = false;
            }, 0);

            this.title = "Add new theme"
        },
        edit() {
            if (this.selectedTheme && this.selectedTheme != '') {
                this.mode = 'edit'

                this.themeDTO = JSON.parse(JSON.stringify(this.$store.getters.getThemeFromCode(this.selectedTheme)));
                this.title = "Edit theme - " + this.themeDTO.name
                this.selectedThemeDTO = this.themeDTO
                const theme = document.querySelector('mosaic-user-defined-theme')
                const variables = JSON.parse(this.themeDTO.variables)
                theme.theme = variables;
                theme.preview()

                this.$store.dispatch('updatePreviewMode', true)
            }
        },
        changeTheme(e) {
            this.selectedTheme = e.target.value
            this.reset()
        },
        reset() {
            this.themeDTO = {}
            this.mode = null
        },
        deleteTheme() {
            if (this.selectedTheme && this.selectedTheme != '') {
                this.themeDTO = this.$store.getters.getThemeFromCode(this.selectedTheme)
                this.selectedThemeDTO = this.themeDTO;
                this.savingTheme = true
                AdminThemesAPI.deleteUserDefinedTheme(this.selectedThemeDTO.id).then(result => {
                    let notification = {
                        "msg": ""
                    }
                    if (result && !result.error && result.data) {

                        notification.msg = 'Theme deleted successfully'
                        EventBus.$emit('success-notification', notification);
                        setTimeout(() => {
                            this.selectedTheme = '';
                            this.$refs.themeRef.value = '';
                            this.reset();
                            this.$refs.themeDialogRef.close()
                            EventBus.$emit('reload-admin-themes');
                        }, 500);
                    } else if (result && result.error) {

                        notification.msg = result.message;

                        EventBus.$emit('error-notification', notification);
                    }
                }).finally(() => {
                    this.savingTheme = false
                })
            } else {
                let notification = {
                    "msg": "Please select a theme to delete"
                }
                EventBus.$emit('error-notification', notification);
            }

        }
    }
}
</script>

<style></style>
